module.exports = __webpack_public_path__ + "img/alipay-square.63112997.svg";